function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
import './GoogleMaps.css';
import React from 'react';
import { Map, Marker, GoogleApiWrapper as GoogleMap, InfoWindow } from 'google-maps-react';
import { canUseDOM, get, hexToRgb } from '../../../utils';
import { tealiumClickFunc, tealiumMergeClickData } from '../../../utils/tealium';
export const defaultMapState = {
  lat: 25.2048493,
  lng: 55.2707828,
  activeMarker: 0,
  markers: [{}]
};
export const googleMapDirectionLink = (lat, lng) => {
  return `https://www.google.com/maps/dir/?api=1&destination=${lat},${lng}`;
};
const defaultMarker = 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIzNC4xNjEiIGhlaWdodD0iNDMuMDY0IiB2aWV3Qm94PSIwIDAgMzQuMTYxIDQzLjA2NCI+DQogIDxnIGlkPSJub3VuX0xvY2F0aW9uXzMwMjAzNzYiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC03Ni43NTggLTE5NC40NTgpIj4NCiAgICA8ZyBpZD0iRWxsaXBzZV8xMDMiIGRhdGEtbmFtZT0iRWxsaXBzZSAxMDMiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDg2Ljc1OCAyMDMuOTYxKSIgZmlsbD0iI2ZmZiIgc3Ryb2tlPSIjNzA3MDcwIiBzdHJva2Utd2lkdGg9IjEiPg0KICAgICAgPGNpcmNsZSBjeD0iNy41IiBjeT0iNy41IiByPSI3LjUiIHN0cm9rZT0ibm9uZSIvPg0KICAgICAgPGNpcmNsZSBjeD0iNy41IiBjeT0iNy41IiByPSI3IiBmaWxsPSJub25lIi8+DQogICAgPC9nPg0KICAgIDxnIGlkPSJHcm91cF81NyIgZGF0YS1uYW1lPSJHcm91cCA1NyIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoNzYuNzU4IDE5NC40NTYpIj4NCiAgICAgIDxwYXRoIGlkPSJTdWJ0cmFjdGlvbl8xIiBkYXRhLW5hbWU9IlN1YnRyYWN0aW9uIDEiIGQ9Ik0tNjQ0NC43OTItMTkwMi40M2ExLjYsMS42LDAsMCwxLTEuMTM4LS40NzEsOTcuMzcsOTcuMzcsMCwwLDEtMTAuNzEzLTEyLjMzM2MtMy40ODEtNS4wMzctNS4yMzMtOS42MjQtNS4zNTYtMTQuMDIxdi0uMDg0YTE2LjYxOSwxNi42MTksMCwwLDEsNC45NzgtMTEuMjkyLDE3LjEzOSwxNy4xMzksMCwwLDEsMTEuNzU3LTQuODYxYy4xMTgsMCwuMjM2LDAsLjM1NCwwYTE3LjUsMTcuNSwwLDAsMSwxMS44OTQsNC41NjcsMTUuNzQyLDE1Ljc0MiwwLDAsMSw1LjE3NiwxMS4ydi4wMWMuMDY5LDQuMzM0LTEuMjkyLDguNjE3LTQuMTYzLDEzLjA5M2E3OS40NzIsNzkuNDcyLDAsMCwxLTkuMDQ5LDEwLjkyNmwtLjA0NC4wNDdjLS44NzIuOTM0LTEuNjk1LDEuODE2LTIuNTA1LDIuNzA5YTEuNTkyLDEuNTkyLDAsMCwxLTEuMTUzLjUxMlptLjI5Mi0zMS41NjFhNC41LDQuNSwwLDAsMC00LjUsNC41LDQuNTA1LDQuNTA1LDAsMCwwLDQuNSw0LjUsNC41MDYsNC41MDYsMCwwLDAsNC41LTQuNUE0LjUsNC41LDAsMCwwLTY0NDQuNS0xOTMzLjk5MVoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDY0NjIgMTk0NS40OTcpIiBmaWxsPSIjMDA2N2I5Ii8+DQogICAgPC9nPg0KICA8L2c+DQo8L3N2Zz4NCg==';
class MapContainer extends React.Component {
  constructor(props) {
    super(props);
    this.primary = void 0;
    this.primary_active = void 0;
    this.activeMarker = -1;
    this.mapRef = void 0;
    this.setBound = () => {
      const {
        mapState
      } = this.props;
      if (this.props.google) {
        if (mapState.markers[0].lat && mapState.markers[0].lng) {
          let bounds = new this.props.google.maps.LatLngBounds();

          // when map is clicked, set bounds to all markers and zoom out to show all markers
          if (this.state.isMapClicked) {
            mapState.markers.forEach(marker => {
              let lat = Number(marker.lat);
              let lng = Number(marker.lng);
              bounds.extend({
                lat,
                lng
              });
              return true;
            });

            // task queue, set isMapClicked to false for working with pin below the map (M60)
            setTimeout(() => {
              this.setState(state => {
                return _objectSpread(_objectSpread({}, state), {}, {
                  isMapClicked: false
                });
              });
            }, 10);
            return bounds;
          }
          mapState.markers.some(marker => {
            let lat = Number(marker.lat);
            let lng = Number(marker.lng);
            if (marker.centered) {
              bounds = new this.props.google.maps.LatLngBounds();
              bounds.extend({
                lat,
                lng
              });
            } else {
              bounds.extend({
                lat,
                lng
              });
            }
            return marker.centered;
          });
          return bounds;
        }
      }
    };
    this.onMouseOverMarker = (index, markerProps, marker, _ref) => {
      let {
        domEvent
      } = _ref;
      const toggleColor = () => {
        if (this.primary !== this.primary_active) {
          if (~icon.url.indexOf(this.primary)) {
            icon.url = icon.url.replace(this.primary, this.primary_active);
            marker.setIcon(icon);
          } else {
            icon.url = icon.url.replace(this.primary_active, this.primary);
            marker.setIcon(icon);
          }
        }
      };
      if (this.state.activeMarker === index) {
        return;
      } else if (this.state.activeMarker === -1 && index === 0) {
        return;
      }
      const icon = marker.getIcon();
      if (domEvent.type === 'mouseover') {
        toggleColor();
        marker.setZIndex(30);
      } else if (domEvent.type === 'mouseout') {
        toggleColor();
        marker.setZIndex(index);
      }
    };
    this.onMarkerCallback = (index, maps, marker) => {
      const {
        analytics
      } = this.props;
      const {
        map
      } = maps;
      const {
        lng,
        lat
      } = map.center;
      const center = {
        lng: lng(),
        lat: lat()
      };
      const center2 = {
        lng: marker.position.lng(),
        lat: marker.position.lat()
      };
      this.props.isCenterOnMarkerClick && map.panTo(center2);
      this.activeMarker = index;
      this.props.markerCallback && this.props.markerCallback(marker, this.props.isCenterOnMarkerClick ? center2 : center, true);
      this.setState(state => {
        return _objectSpread(_objectSpread({}, state), {}, {
          activeMarker: index,
          center: this.props.isCenterOnMarkerClick ? center2 : center,
          markerObject: marker,
          showingInfoWindow: this.props.contactCardLocationTitle ? !state.showingInfoWindow : false,
          // toggle info window only when contactCardLocationTitle is true
          isMapClicked: Boolean(this.props.mapMarkerZoomOut) ? true : false
        });
      });
      if (analytics) {
        tealiumClickFunc(tealiumMergeClickData(analytics['analytics'], analytics['params']), analytics['text']);
      }
    };
    this.mapReadyHandler = () => {
      const {
        callback
      } = this.props;
      callback(this.mapRef);
      setTimeout(() => {
        const current = this.mapRef.current && this.mapRef.current;
        if (current) {
          const block = current.refs.map.querySelector('[role="region"]');
          if (block) {
            block.removeAttribute("aria-roledescription");
          }
          const map = current.map;
          if (map && map.controls && this.props.cameraControlPosition) {
            if (this.props.isKDramaMap) {
              map.setOptions({
                cameraControl: true,
                cameraControlOptions: {
                  position: google.maps.ControlPosition[this.props.cameraControlPosition]
                }
              });
            } else {
              map.setOptions({
                cameraControl: true,
                cameraControlOptions: {
                  position: google.maps.ControlPosition[this.props.cameraControlPosition]
                },
                zoom: this.props.zoom
              });
            }
          }
        }
      }, 300);
    };
    this.onMapClick = () => {
      this.setState(state => {
        return _objectSpread(_objectSpread({}, state), {}, {
          activeMarker: -1,
          showingInfoWindow: false,
          markerObject: null,
          isMapClicked: true
        });
      });
    };
    this.onMapDragEnd = (mapProps, map) => {
      const center = map.getCenter();
      this.setState({
        userMovedMap: true,
        userCenter: {
          lat: center.lat(),
          lng: center.lng()
        }
      });
    };
    const isColorBlind = canUseDOM ? Boolean(document.getElementsByClassName("contrast").length) : false;
    this.state = {
      activeMarker: -1,
      maxZoom: 0,
      isColorBlind,
      showingInfoWindow: false,
      markerObject: null,
      userMovedMap: false,
      userCenter: null,
      isMapClicked: false
    };
    this.mapRef = /*#__PURE__*/React.createRef();
    let primary = get(this.props.theme, 'primary', '');
    let primary_active = get(this.props.theme, 'primary_active', '');
    let style = {};
    if (typeof window !== 'undefined') {
      style = window.getComputedStyle(document.querySelector('html'));
    }
    if (~primary.indexOf('--')) {
      primary = style.getPropertyValue(primary);
    }
    if (~primary_active.indexOf('--')) {
      primary_active = style.getPropertyValue(primary_active);
    }
    if (canUseDOM && document.body.classList.contains('vdsite')) {
      this.primary = primary ? hexToRgb(primary) : 'rgb(82 82 82)';
      this.primary_active = primary_active ? hexToRgb(primary_active) : 'rgb(0 103 185)';
    } else if (!document.body.classList.contains('vdsite')) {
      this.primary = primary ? hexToRgb(primary) : 'rgb(0 144 154)';
      this.primary_active = primary_active ? hexToRgb(primary_active) : 'rgb(17 94 103)';
    } else {
      this.primary = primary ? hexToRgb(primary) : 'rgb(82 82 82)';
      this.primary_active = primary_active ? hexToRgb(primary_active) : 'rgb(0 103 185)';
    }
  }
  componentDidMount() {
    const current = this.mapRef.current && this.mapRef.current;
    // @ts-ignore
    const map = current.map;
    if (map && this.props.maxZoomActive) {
      const listener = google.maps.event.addListener(map, "idle", () => {
        this.setState(state => {
          return _objectSpread(_objectSpread({}, state), {}, {
            maxZoom: map.getZoom() + this.props.zoomedLevel
          });
        });
        map.setOptions({
          maxZoom: map.getZoom() + this.props.zoomedLevel
        });
        google.maps.event.removeListener(listener);
      });
    }
  }
  // componentDidUpdate () {
  //   const current = this.mapRef.current && this.mapRef.current
  //   // @ts-ignore
  //   const map = current.map
  //   if(map && this.props.maxZoomActive) {
  //      const listener = google.maps.event.addListener(map, "idle", () => {
  //         const maxZoom = this.state.maxZoom || 0
  //         if(maxZoom !=0 && map.getZoom() > maxZoom )
  //           map.setZoom(this.state.maxZoom)
  //
  //         google.maps.event.removeListener(listener);
  //       });
  //
  //
  //   }
  //
  // }
  componentDidUpdate() {}
  shouldComponentUpdate(nextProps, nextState) {
    const currentValueOfColorBlind = canUseDOM ? Boolean(document.getElementsByClassName("contrast").length) : false;
    if (nextState.isColorBlind !== currentValueOfColorBlind) {
      nextState.isColorBlind = currentValueOfColorBlind;
      return true;
    }
    const {
      mapState
    } = this.props;
    if (nextState.activeMarker !== this.state.activeMarker || nextState.showingInfoWindow !== this.state.showingInfoWindow || nextState.markerObject !== this.state.markerObject || mapState !== nextProps.mapState) {
      if (this.props.zoom !== nextProps.zoom) {
        setTimeout(() => {
          const current = this.mapRef.current && this.mapRef.current;
          if (current) {
            const map = current.map;
            if (map && map.controls) {
              map.setOptions({
                zoom: this.props.zoom
              });
            }
          }
        }, 100);
      }
      return true;
    }
    return false;
  }
  componentWillReceiveProps(_ref2) {
    let {
      mapState
    } = _ref2;
    if (mapState.activeMarker !== this.state.activeMarker) {
      this.setState(state => {
        return _objectSpread(_objectSpread({}, state), {}, {
          activeMarker: mapState.activeMarker
        });
      });
    }
  }
  render() {
    let {
      zoom,
      google,
      mapState,
      customMarker,
      disableBound,
      allowZoomControl = true,
      zoomChanged,
      visible = true,
      isDetSite = false,
      contactCardLocationTitle = '',
      isKDramaMap = false
    } = this.props;
    let options;
    let center = {};
    const shouldUseUserCenter = this.state.userMovedMap && this.state.userCenter;
    const mapCenter = shouldUseUserCenter ? this.state.userCenter : {
      lat: mapState.lat,
      lng: mapState.lng
    };
    if (mapState.markers.length < 2 || disableBound && !isKDramaMap) {
      options = {
        zoom: zoom,
        center: mapCenter
      };
    } else {
      let bounds = this.setBound();
      options = {
        bounds
      };
    }
    if (isKDramaMap) {
      if (mapState.markers.length < 2 || disableBound) {
        let bounds = this.setBound();
        options = {
          bounds
        };
      }
    }
    const onReady = () => this.mapReadyHandler();
    center = options.center;
    return /*#__PURE__*/React.createElement("div", {
      className: commonStyles
    }, /*#__PURE__*/React.createElement("div", {
      className: "googleMapId"
    }, /*#__PURE__*/React.createElement(Map, _extends({
      ref: this.mapRef,
      google: google
    }, options, {
      visible: visible,
      onReady: onReady,
      center: center,
      streetViewControl: false,
      scaleControl: false,
      mapTypeControl: false,
      zoomControl: allowZoomControl,
      onZoomChanged: zoomChanged,
      fullscreenControl: false,
      keyboardShortcuts: false,
      onClick: this.onMapClick,
      onDragend: this.onMapDragEnd,
      initialCenter: {
        lat: mapState.lat,
        lng: mapState.lng
      },
      styles: isDetSite && [{
        "featureType": "landscape.man_made",
        "elementType": "geometry.fill",
        "stylers": [{
          "color": "#f5f4f7"
        }]
      }, {
        "featureType": "landscape.man_made",
        "elementType": "geometry.stroke",
        "stylers": [{
          "color": "#262f18"
        }]
      }, {
        "featureType": "landscape.natural",
        "stylers": [{
          "color": "#dde2eb"
        }]
      }, {
        "featureType": "poi",
        "elementType": "geometry",
        "stylers": [{
          "color": "#c0c6cf"
        }]
      }, {
        "featureType": "poi.park",
        "elementType": "geometry",
        "stylers": [{
          "color": "#dde2eb"
        }]
      }, {
        "featureType": "road",
        "stylers": [{
          "color": "#ffffff"
        }]
      }, {
        "featureType": "water",
        "stylers": [{
          "color": "#e3f0ff"
        }]
      }]
    }), google && mapState.markers && mapState.markers.map((marker, index) => {
      const isContrastMode = document.getElementsByClassName("contrast").length;
      const fillColorForMultiplePins = mapState.activeMarker === index || this.state.activeMarker == index ? isContrastMode ? "rgba(155, 155, 155)" : this.primary_active : this.primary;
      const fillColorForOnePin = this.state.activeMarker === -1 && mapState.activeMarker === index || this.state.activeMarker === index ? this.primary_active : this.primary;
      const lat = Number(marker.lat);
      const lng = Number(marker.lng);
      return /*#__PURE__*/React.createElement(Marker, {
        key: index,
        label: customMarker && mapState.markers.length > 1 ? {
          text: `${index + 1}`,
          color: '#fff',
          fontSize: '1.125rem',
          fontWeight: "400"
        } : '',
        title: marker.title,
        icon: isDetSite ? createDetSiteMarker(Boolean(isContrastMode)) : customMarker && mapState.markers.length > 1 ? {
          url: `data:image/svg+xml;utf-8, <svg width="40" height="60" viewBox="0 0 40 60" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M5.85786 6.15076C9.60859 2.21249 14.6957 0 20 0C25.3043 0 30.3914 2.21249 34.1421 6.15076C37.8929 10.089 40 15.4305 40 21C40 36.75 20 60 20 60C20 60 0 36.75 0 21C0 15.4305 2.10714 10.089 5.85786 6.15076Z" fill="${fillColorForMultiplePins}"/>
                          </svg>`,
          //  anchor: new google.maps.Point(41, 60),
          scaledSize: new google.maps.Size(40, 60),
          labelOrigin: new google.maps.Point(20, 25)
        } : {
          url: `data:image/svg+xml;utf-8, <svg width="36" height="50" viewBox="0 0 36 50" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M18 23.75C16.3424 23.75 14.7527 23.0915 13.5806 21.9194C12.4085 20.7473 11.75 19.1576 11.75 17.5C11.75 15.8424 12.4085 14.2527 13.5806 13.0806C14.7527 11.9085 16.3424 11.25 18 11.25C19.6576 11.25 21.2473 11.9085 22.4194 13.0806C23.5915 14.2527 24.25 15.8424 24.25 17.5C24.25 18.3208 24.0883 19.1335 23.7742 19.8918C23.4602 20.6501 22.9998 21.3391 22.4194 21.9194C21.8391 22.4998 21.1501 22.9602 20.3918 23.2742C19.6335 23.5883 18.8208 23.75 18 23.75ZM18 0C13.3587 0 8.90752 1.84374 5.62563 5.12563C2.34374 8.40752 0.5 12.8587 0.5 17.5C0.5 30.625 18 50 18 50C18 50 35.5 30.625 35.5 17.5C35.5 12.8587 33.6563 8.40752 30.3744 5.12563C27.0925 1.84374 22.6413 0 18 0Z" fill="${fillColorForOnePin}"/>
                              </svg>`,
          //  anchor: new google.maps.Point(34, 43),
          scaledSize: new google.maps.Size(35, 50)
        },
        onMouseout: this.onMouseOverMarker.bind(this, index),
        onClick: this.onMarkerCallback.bind(this, index),
        onMouseover: this.onMouseOverMarker.bind(this, index),
        position: {
          lat,
          lng
        },
        zIndex: index >= 0 && mapState.activeMarker === index || this.state.activeMarker == index ? mapState.markers.length + 1 : index
      });
    }), contactCardLocationTitle && isDetSite && /*#__PURE__*/React.createElement(InfoWindow, {
      visible: this.state.showingInfoWindow,
      marker: this.state.markerObject,
      position: this.state.center
    }, /*#__PURE__*/React.createElement("div", {
      style: {
        fontSize: '1.125rem',
        lineHeight: '120%',
        fontWeight: '400',
        color: '#000',
        margin: '0',
        padding: '0'
      }
    }, contactCardLocationTitle)))));
  }
}
export default GoogleMap(props => ({
  apiKey: !process.env.STORYBOOK_MODE && canUseDOM ? props.mapKey : 'AIzaSyB4GL2flAQBGxzOjrbVXQUvpU2UqJfoPo8',
  language: !process.env.STORYBOOK_MODE && canUseDOM ? props.language : 'en'
}))(MapContainer);
const commonStyles = "cjamj6l";
const createDetSiteMarker = function () {
  let isContrastMode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  const svgString = `<svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 36 36" fill="none"><path d="M18 33C25.732 33 32 26.732 32 18C32 9.26801 25.732 3 18 3C10.268 3 4 9.26801 4 18C4 26.732 10.268 33 18 33Z" fill="#C8FAFF" stroke="#B2D5FFA6" stroke-width="3" stroke-opacity="0.6"/><path d="M18 25C21.866 25 25 21.866 25 18C25 14.134 21.866 11 18 11C14.134 11 11 14.134 11 18C11 21.866 14.134 25 18 25Z" fill="#005F66"/></svg>`;
  const svgStringDark = `<svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 36 36" fill="none"><path d="M18 33C25.732 33 32 26.732 32 18C32 9.26801 25.732 3 18 3C10.268 3 4 9.26801 4 18C4 26.732 10.268 33 18 33Z" fill="#FFFFFF" stroke="#000000" stroke-width="3"/><path d="M18 25C21.866 25 25 21.866 25 18C25 14.134 21.866 11 18 11C14.134 11 11 14.134 11 18C11 21.866 14.134 25 18 25Z" fill="#000000"/></svg>`;
  return {
    url: `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(isContrastMode ? svgStringDark : svgString)}`,
    scaledSize: new google.maps.Size(36, 36),
    anchor: new google.maps.Point(18, 18)
  };
};